import ContentAdCampaignModel from './ContentAdCampaignModel';
import ExportModel from '../../lib/ExportModel';

export default {
  async getConfig(account) {
    // Create Campaign Model
    const campaignModel = new ContentAdCampaignModel(account);
    return ExportModel(campaignModel);
  },
};
